import React from 'react'

type Props = { username: string; user: string; date: string; time: string }

export const ResolvedByChannels = ({ username, date, time }: Props): JSX.Element => (
    <>
        Resolved at {date} {time}
        <br /> By <strong>{username}</strong>
    </>
)

export const ResolvedByChannelsPT = ({ username, date, time }: Props): JSX.Element => (
    <>
        Resolvido em {date} {time} <br /> Por <strong>{username}</strong>
    </>
)

export const FalsePositiveByChannels = ({ username, date, time }: Props): JSX.Element => (
    <>
        False alert at {date} {time}
        <br /> By <strong>{username}</strong>
    </>
)

export const FalsePositiveByChannelsPT = ({ username, date, time }: Props): JSX.Element => (
    <>
        Falso alerta em {date} {time}
        <br /> Por <strong>{username}</strong>
    </>
)
